import { DEFAULT_LANGUAGE } from '@erpagroapp/common';
import { useSettingRef } from '@erpagroapp/settings';
import { createI18n } from 'vue-i18n';

function loadLocaleMessages() {
  const locales = import.meta.webpackContext('.', {
    regExp: /[\w\-,\s]+\.json$/i,
    mode: 'sync',
  });

  const messages = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([\w-]+)\./);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });

  return messages;
}

export function createI18nInstance() {
  const language = useSettingRef('App.Idioma');

  return createI18n({
    legacy: false,
    locale: language.value.Code,
    fallbackLocale: DEFAULT_LANGUAGE.Code, // Cuando el locale seleccionado no esta disponible.
    messages: loadLocaleMessages(),
  });
}
